__turbopack_context__.v({
  "askNote": "X3v--q_askNote",
  "categoryLabel": "X3v--q_categoryLabel",
  "categoryPill": "X3v--q_categoryPill",
  "categorySwatch": "X3v--q_categorySwatch",
  "container": "X3v--q_container",
  "deck": "X3v--q_deck",
  "eyebrow": "X3v--q_eyebrow",
  "eyebrowGroup": "X3v--q_eyebrowGroup",
  "eyebrowRow": "X3v--q_eyebrowRow",
  "goDeeperContainer": "X3v--q_goDeeperContainer",
  "goDeeperHeading": "X3v--q_goDeeperHeading",
  "heading": "X3v--q_heading",
  "headingBlock": "X3v--q_headingBlock",
  "noteBody": "X3v--q_noteBody",
  "noteContainer": "X3v--q_noteContainer",
  "prose": "X3v--q_prose",
  "proseBody": "X3v--q_proseBody",
  "refContainer": "X3v--q_refContainer",
  "relArrow": "X3v--q_relArrow",
  "relBody": "X3v--q_relBody",
  "relCard": "X3v--q_relCard",
  "relCat": "X3v--q_relCat",
  "relImg": "X3v--q_relImg",
  "relImgEl": "X3v--q_relImgEl",
  "relList": "X3v--q_relList",
  "relTitle": "X3v--q_relTitle",
  "section": "X3v--q_section",
  "separator": "X3v--q_separator",
  "stand": "X3v--q_stand",
});
